module.exports = __webpack_public_path__ + "static/media/arrow.999a489e.svg";